var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarmBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 1 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10.825 18 11.5 17.2615 11.5 16.359H8.5C8.5 17.2615 9.1675 18 10 18ZM14.5 13.0769V8.97436C14.5 6.45538 13.27 4.34667 11.125 3.78872V3.23077C11.125 2.54974 10.6225 2 10 2C9.3775 2 8.875 2.54974 8.875 3.23077V3.78872C6.7225 4.34667 5.5 6.44718 5.5 8.97436V13.0769L4 14.7179V15.5385H16V14.7179L14.5 13.0769Z",
    fill: "#1D4ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmBlue);
export default __webpack_public_path__ + "static/media/icon-alarm-blue.910ffabb74889ce46cadc0d84564d328.svg";
export { ForwardRef as ReactComponent };